/**
 * Densité de rendu des canevas dessinés à la main.
 *
 * Un canevas HTML a deux tailles : celle de sa mémoire d'image et celle que le
 * CSS lui donne à l'écran. Quand la première est plus petite, le navigateur
 * étire — et le tracé sort mou. La densité de l'écran est donc reprise telle
 * quelle, jamais plafonnée : les vues Android correspondantes dessinent sur le
 * canevas de la fenêtre, en pixels physiques, et multiplient leurs dimensions
 * par `resources.displayMetrics.density` pour cette raison précise.
 *
 * Le plafond à 2 qui existait ici faisait rendre à 2× puis étirer à 3× sur la
 * plupart des téléphones récents. Il est parti avec celui de la carte : le
 * remettre pour ces canevas-là n'économiserait presque rien — quelques
 * centaines de traits redessinés au tick, sans commune mesure avec une scène
 * cartographique par image.
 */
export function canvasPixelRatio(): number {
  if (typeof window === 'undefined') return 1
  return window.devicePixelRatio || 1
}
